import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

/**
 * Component for presenting boolean content
 */
@ngCore.Component({
  selector: 'atn-boolean-content',
  template: `<div>{{ displayValueSg() }}</div>`,
})
export class Component {
  /** @see {@link ents.core.common.value.Raw} */
  public readonly valueSg = ngCore.input<boolean | undefined>(undefined, {
    alias: 'value',
  })

  /**
   * Computes the display label based on the {@link ents.core.common.value.Raw} of the type BOOL.
   * Returns 'Yes' for true, 'No' for false, and an empty string for undefined or invalid values.
   */
  public readonly displayValueSg = ngCore.computed((value = this.valueSg()) =>
    value === true ? 'Yes' : value === false ? 'No' : '',
  )
}
